import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'shabic-icon-image',
  templateUrl: './icon-image.component.html',
  styleUrls: ['./icon-image.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconImageComponent {}
